import React from 'react';

import {
	ScatterChart,
	Scatter,
	Cell,
	XAxis,
	YAxis,
	ZAxis,
	CartesianGrid,
	Tooltip,
	ResponsiveContainer,
} from 'recharts';

import { Grid, Typography } from '@material-ui/core';

const colors = ['#007487', '#f7cd00', '#C60298'];

const BsScatterChart = ({
	data,
	xAxisName,
	yAxisName,
	zAxisName,
	dataKeyX,
	dataKeyY,
	dataKeyZ,
	unitX,
	unitY,
	unitZ,
}) => (
	<Grid>
		<Typography variant="body1" style={{ marginLeft: '62px', marginBottom: '12px' }}>
			{yAxisName}
		</Typography>
		<ResponsiveContainer width="100%" height={400}>
			<ScatterChart margin={{ top: 20, right: 20, bottom: 20, left: 20 }}>
				<XAxis
					type="number"
					dataKey={`${dataKeyX}`}
					name={xAxisName}
					unit={unitX}
				/>
				<YAxis
					type="number"
					dataKey={`${dataKeyY}`}
					name={yAxisName}
					unit={unitY}
				/>
				<ZAxis
					dataKey={`${dataKeyZ}`}
					range={[400, 1200]}
					name={zAxisName}
					unit={unitZ}
				/>
				<CartesianGrid stroke="#083142" strokeDasharray="4 4" />
				<Tooltip cursor={{ strokeDasharray: '3 3' }} />
				<Scatter name="A school" data={data}>
					{data.map((entry, index) => (
						<Cell
							key={`cell-${index}`}
							fill={colors[index % colors.length]}
							style={{ opacity: '0.7' }}
						/>
					))}
				</Scatter>
			</ScatterChart>
		</ResponsiveContainer>
		<Typography
			variant="body1"
			style={{ textAlign: 'right', marginTop: '-12px', marginRight: '15px' }}
		>
			{xAxisName}
		</Typography>
	</Grid>
);

export default BsScatterChart;
